var render = function render(){var _vm=this,_c=_vm._self._c;return (
    (_vm.option.isAdmin && _vm.isAdmin && !_vm.currentBranch) ||
    (_vm.option.isModirAdmin && _vm.isModirAdmin) ||
    (_vm.option.isReporter && _vm.isReporter) ||
    (_vm.option.isModir && _vm.isModir) ||
    (_vm.option.isHesabdar && _vm.isHesabdar) ||
    (_vm.option.isAshpaz && _vm.isAshpaz) ||
    (_vm.option.isEnduser && _vm.isEnduser)
  )?_c('div',[(_vm.option.route)?_c('app-option',{attrs:{"icon":_vm.option.icon,"title":_vm.option.title,"route":_vm.option.route,"value":_vm.option.value},on:{"closeSlider":function($event){return _vm.$emit('closeSlider')}}}):(_vm.showHeader)?[_c('app-title',{attrs:{"title":_vm.option.title}})]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }